















































































import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;
import {CartEvents, SolarDataLayer} from "@flashpointbv/solar-datalayer/dist";

@Component(
  {
    name: 'catalog-product-configuration',
    components: ServiceContainer().getComponents()
  }
)

export default class extends Vue {
  $refs!: {
    addToCart: HTMLElement;
    offcanvasTrigger: HTMLElement;
  }

  @Prop({default: false}) private readonly enableTooltip: boolean;
  @Prop({default: 1}) private qtyIncrement: number;
  @Prop({default: () => []}) private wishlistItems: Array<object>;
  @Prop() private readonly productData: object;
  @Prop() private readonly productBundleData: { selections: {}[] }[];
  @Prop({
    default: () => {
      return {};
    }
  }) private reviews: object;
  @Prop({default: () => []}) private readonly relatedItems;
  @Prop({default: true}) readonly showCompare: boolean;

  private _throttle: number;
  private showTooltip: boolean = false;
  protected qty: number = 1;
  private addToCartIsLoading: boolean = false;
  private hasAddToCartSuccess: boolean = false;
  private hasAddToCartSuccessMessage: TranslateResult = '';
  private wishlistToggle: boolean = this.isOnWishlist;
  private loadingWishlist: boolean = false;

  private get selectedOptions(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedOptions'];
  }

  private get isCompare(): boolean {
    return this.$store.state.CatalogCategoryCompare.productsToCompare.filter(p => p.sku === this.productData['sku']).length;
  }

  private set isCompare(compareCheck: boolean) {
    this.$store.dispatch('CatalogCategoryCompare/setProductsToCompare', {
      product: this.productData,
      isCompare: compareCheck
    });
  }

  private get isOnWishlist(): boolean {
    if (!this.wishlistItems) {
      return false;
    }

    return !!this.wishlistItems.filter(p => p['id'] === this.productData['id']).length;
  }

  private async toggleWishlist(): Promise<void> {
    this.loadingWishlist = true;
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.productData['product_id']);
      await this.$store.dispatch('CustomerWishlist/updateWishlistCount', !this.wishlistToggle);
      this.wishlistToggle = !this.wishlistToggle;
    } catch (e) {
      //
    } finally {
      this.loadingWishlist = false;
    }
  }

  private addToCartTooltip(e): void {
    if (!this.isSaleable && this.enableTooltip && this.productData['product_type'] === 'configurable') {
      if (e.type === 'mouseenter') {
        this.showTooltip = true;
        if (this.$mobileDetect.mobile()) {
          (document.getElementsByClassName('product__option')[0] as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      } else {
        clearTimeout(this._throttle);
        this._throttle = window.setTimeout(() => {
          this.showTooltip = false;
        }, 1000);
      }
    }
  }

  private get isSaleable(): boolean {
    return this.$store.getters['CatalogProduct/isSaleable'] && (this.productData['in_stock'] || !this.productData['manage_stock']);
  }

  private get hasAddToCartError(): boolean {
    return this.$store.state.CheckoutCart.addToCartError;
  }

  private get addToCartErrorMessage(): string {
    return this.$store.state.CheckoutCart.cartMessage;
  }

  private changeQty(a): void {
    if (typeof this.qty !== 'string' && this.qty > 0) {
      this.qty = a === '+' ? (this.qty + this.qtyIncrement) : a === '-' && this.qty > 0 ? (this.qty - this.qtyIncrement) : (Math.ceil(this.qty / this.qtyIncrement) * this.qtyIncrement);
    } else {
      this.qty = 1;
    }
  }

  private async productAddToCart(): Promise<void> {
    this.addToCartIsLoading = true;

    try {
      let productPayload = {
        sku: this.productData['sku'],
        qty: this.qty,
      };

      if (this.productData['product_type'] === 'configurable' && this.selectedOptions.length > 0) {
        const productOptions = {
          product_option: {
            extension_attributes: {
              configurable_item_options: this.selectedOptions.map(option => {
                return {
                  option_id: option['attributeId'],
                  option_value: option['selectedValue']
                }
              })
            }
          }
        }
        productPayload = Object.assign(productPayload, productOptions);
      }
      await this.$store.dispatch('CheckoutCart/addProductToQuote', productPayload);

      if (this.hasAddToCartError) {
        this.addToCartIsLoading = false;
        return;
      }

      this.hasAddToCartSuccessMessage = this.$t('Product has been added to your shopping cart');
      this.hasAddToCartSuccess = true;

      setTimeout(() => {
        this.hasAddToCartSuccess = false;
      }, 5000);
      this.$refs.offcanvasTrigger.click();
      SolarDataLayer.init().addAddToCart({
        ...this.productData,
        'item_id': this.productData['product_id'],
        'item_group_id': this.productData['pim_productfamilie'] || this.productData['product_id'],
        'item_variant': '',
        'item_variant_id': this.productData['product_id'],
      }, CartEvents.ADD, this.qty);
      this.facebookEvent('AddToCart');
    } catch (e) {
      console.log(e);
    } finally {
      this.addToCartIsLoading = false;
    }
  }

  private created(): void {
    this.$store.dispatch('CatalogProduct/getProductData', this.productData);
    if (this.productBundleData.length > 0) {
      this.$store.dispatch('CatalogBundleProduct/getAvailableOptions', this.productBundleData);
    }
    SolarDataLayer.init().addViewItem({
      ...this.productData,
      'item_id': this.productData['product_id'],
      'item_group_id': this.productData['pim_productfamilie'] || this.productData['product_id'],
      'item_variant': '',
      'item_variant_id': this.productData['product_id'],
    });
    this.facebookEvent('ViewContent');
  }
  private mounted(): void{
    this.$root.$on('add-to-cart', this.productAddToCart);
  }
  private facebookEvent(type): void {
    window.fbq('track', type, {
      value: this.productData['final_price_incl_tax'],
      currency: 'EUR',
      contents: [{
        id: this.productData['product_id'],
        sku: this.productData['sku'],
        quantity: this.qty
      }],
      content_type: 'product',
    });
  }
}
